export const sleep = async (timeoutMs: number): Promise<void> => new Promise(resolve => setTimeout(resolve, timeoutMs));
